<template>
    <div class="m-mask" v-if="isLoading">
        <div class="m-container">

            <div class="m-header">
                <slot name="header">
                    <h1 class="text-center">{{ 'Loader.Waiting' | translate }}</h1>
                </slot>
            </div>

            <div class="m-body">
                <slot name="body">
                    <div class="text-center mx-auto my-2"><span class="fa fa-circle-o-notch fa-spin fa-3x fa-fw"></span></div>
                </slot>
            </div>

            <div class="m-footer">
                <slot name="footer">
                    <h4 class="text-center">{{ 'Loader.Progress' | translate }}</h4>
                </slot>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'Loader',
        computed: {
            isLoading() {
                return this.$store.state.isLoading;
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .m-mask {
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(102, 102, 102, .5);
        transition: opacity .3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .m-container {
        width: 300px;
        margin: 0px auto;
        padding: 20px;
        background-color: #ffffff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
    }
</style>